import { TMutation, TQuery } from 'app/Requests/types';
import httpDriver from 'app/utils/httpDriver';
import { apiRoutes } from 'auth/utils/apiRoutes';
export const getAuthorizedModules = async (): Promise<any> => {
  const { data } = await httpDriver.post(apiRoutes.authorizedModules, {});
  return data?.payload?.records?.modules;
};

const getRecaptchaHeader = (token: string) => {
  return {
    headers: {
      'X-Auth-Token': token,
    },
  };
};

export const logout = async (): Promise<any> => {
  const { data } = await httpDriver.get(apiRoutes.logout);
  return data;
};

export const login = async ({ body, token }: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.login,
    body,
    getRecaptchaHeader(token as any)
  );
  return data;
};

export const signup = async ({ body }: TMutation): Promise<any> => {
  const { data } = await httpDriver.post('/register', body);
  return data;
};

export const forgotPassword = async (queryKey: any): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.forgotPassword,
    {
      email: queryKey?.email,
    },
    getRecaptchaHeader(queryKey?.token as any)
  );
  return data;
};

export const verifyResetPasswordToken = async (
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  queryKey: any
): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.verifyResetPasswordToken,
    {
      token: queryKey.token,
    },
    getRecaptchaHeader(queryKey.reToken as any)
  );
  return data;
};

export const resetPassword = async (
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  queryKey: any
): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.resetPassword,
    {
      user_id: queryKey?.userData?.user_id,
      password: queryKey?.userData?.password,
      token: queryKey?.userData?.token,
    },
    getRecaptchaHeader(queryKey?.reToken as any)
  );
  return data;
};

export const twoFactorLogin = async (
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  queryKey: any
): Promise<any> => {
  const { data } = await httpDriver.post(
    apiRoutes.twoFactorLogin,
    {
      user_id: queryKey?.Data?.user_id,
      code: queryKey?.Data?.code,
    },
    getRecaptchaHeader(queryKey?.token as any)
  );
  return data;
};
